'use client';
import React from 'react';
import dynamic from 'next/dynamic';
import type { StockPosition } from './StockPositionsContent';

const StockHealthChartInner = dynamic(() => import('./StockHealthChartInner'), { ssr: false });

export default function StockHealthChart({ data }: { data: StockPosition[] }) {
  return <StockHealthChartInner data={data} />;
}